import { render, staticRenderFns } from "./DegreeError.vue?vue&type=template&id=1ea19790&scoped=true&"
import script from "./DegreeError.vue?vue&type=script&lang=js&"
export * from "./DegreeError.vue?vue&type=script&lang=js&"
import style0 from "./DegreeError.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./DegreeError.vue?vue&type=style&index=1&id=1ea19790&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea19790",
  null
  
)

export default component.exports